<span class="[ truncate ]">{{ label }}</span>

<campus-state-layer [for]="element" class="bg-on-surface-variant"></campus-state-layer>
<campus-focus-ring [for]="element"></campus-focus-ring>
